import { type ReactNode } from 'react'
import { useEntitlements } from '../hooks/useEntitlements'
import { AppLoader } from './AppLoader'
import OrgAccessDeniedPage from '../pages/OrgAccessDeniedPage'

/** Gates an app's whole shell on the signed-in user's ORGANIZATION actually
 *  having this app (services.entitlements.org_has_app — no explicit
 *  AppSubscription row means no access, full stop; see that module's
 *  docstring). Distinct from RequireAppAccess, which checks whether this
 *  particular USER is scoped to an app the org already has. Put this
 *  OUTSIDE RequireAppAccess in the wrapper order — an org that doesn't have
 *  the app at all is the more fundamental reason to stop, regardless of
 *  what any one user's app_scope says. */
export default function RequireOrgEntitlement({
  appKind, appLabel, children,
}: {
  appKind: string
  appLabel: string
  children: ReactNode
}) {
  const { has, loading } = useEntitlements()

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-background">
        <AppLoader />
      </div>
    )
  }

  if (!has(appKind)) {
    return <OrgAccessDeniedPage appKind={appKind} appLabel={appLabel} />
  }

  return <>{children}</>
}
